<template>
  <v-dialog v-model="value" @click:outside="clickOutside" :width="width" :max-width="maxWidth" :persistent="persistent" :fullscreen="fullscreen" scrollable>
    <v-card>
      <v-toolbar color="primary" dark>
        <v-toolbar-title class="font-weight-bold">
          {{ title }}
        </v-toolbar-title>
        <v-spacer/>
        <v-btn icon dark @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pa-0" :style="contentHeight">
        <slot></slot>
      </v-card-text>
      <v-divider v-if="buttons"/>
      <v-card-actions class="justify-end" v-if="buttons">
        <v-btn v-for="(button, index) in buttons" @click.stop="click(index, $event)" :key="index"
               :color="button.color? button.color: 'primary'" :class="button.class" :text="button.text?button.text: false"
               :outlined="button.outlined?button.outlined: false">
          {{button.title}}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'GeneralDialog',
  props: {
    value: {
      default: false,
      type: Boolean
    },
    title: {
      default: '',
      type: String
    },
    width: {
      default: 500
    },
    height: {
      type: [Number, String]
    },
    maxWidth: String,
    persistent: {
      default: false,
      type: Boolean
    },
    fullscreen: {
      default: false,
      type: Boolean
    },
    buttons: {
      type: Array
    }
  },
  computed: {
    contentHeight() {
      if (!this.fullscreen && this.height) {
        if (this.buttons) {
          return { height: (this.height - 117) + 'px' }
        } else {
          return { height: (this.height - 64) + 'px' }
        }
      }
      return {}
    }
  },
  methods: {
    close() {
      this.$emit('input', false)
    },
    clickOutside() {
      if (!this.persistent) {
        this.close()
      }
    },
    click(buttonIndex, event, source = 'click') {
      const button = this.buttons[buttonIndex]
      const handler = button?.handler
      if (typeof handler === 'function') {
        handler(buttonIndex, event, { source })
      }
    }
  }
}
</script>

<style scoped>

</style>
